import { cn } from "./tailwindUtils";

/** Status chip for master/config rows that support drafts (knh-71-BUG-02). */
export function MasterRecordStatusChip({ isActive, isDraft }) {
    if (isDraft) {
        return (
            <span
                className={cn(
                    "px-2 py-1 text-xs font-medium rounded-full",
                    "bg-amber-100 text-amber-800 dark:bg-amber-900/30 dark:text-amber-300",
                )}
            >
                Draft
            </span>
        );
    }
    return (
        <span
            className={cn(
                "px-2 py-1 text-xs font-medium rounded-full",
                isActive
                    ? "bg-green-100 text-green-700 dark:bg-green-900/30 dark:text-green-300"
                    : "bg-red-100 text-red-700 dark:bg-red-900/30 dark:text-red-300",
            )}
        >
            {isActive ? "Active" : "Inactive"}
        </span>
    );
}
